import constant from '../../store/constant'
var utils = require('../../utils')

export default {
  name: 'plan-detail',

  data: function () {
    return {
      plan: {
        plan_id: null,
        patient_id: null,
        facility_id: null,
        plan_date: null,
        // plan_ym: null,
        // plan_ym_last: null,
        shop_id: null,
        creator_id: null,
        clinic_id: null,
        doctor_id: null,
        careoffice_id: null,
        careman_id: null,
        post_no: null,
        address1: null,
        address2: null,
        tel: null,
        emergency_name: null,
        emergency_rel: null,
        emergency_tel: null,
        emergency2_name: null,
        emergency2_rel: null,
        emergency2_tel: null,
        emergency_post_no: null,
        emergency_address1: null,
        emergency_address2: null,
        pay_method: null,
        side_effect_history: null,
        allergy_history: null,
        visit_interval: null,
        visit_weekday: null,
        visit_plan: null,
        body_character: null,
        complication: null,
        lead_plan1: null,
        lead_plan2: null,
        lead_plan3: null,
        lead_plan4: null,
        lead_plan5: null,
        lead_plan6: null,
        special_comment: null,
        meeting_comment: null,
        other_disease_name: null,
        room_no: null,
        create_time: null,
        // update_time: null,
        // del_flag: null,

        patient_name: null,
        patient_name_furigana: null,
        sex: null,
        birthday: null,

        disease_ids: [],
        patient_avartar: null,

        facility_name: null,
        shop_name: null,
        creator_name: null,
        clinic_name: null,
        doctor_name: null,
        careoffice_name: null,
        careman_name: null,

        is_latest: true,
        is_first: true,
        index: 0,
        can_save_next_plan: null,
        enable_flag: null,
        patient_enable: null
      },
      isListKeep: true,

      // 確認ダイアログ用
      confirmTitle: this.$t('plan.confirm_title'),
      confirmMessage: '',
      confirmOnYes: () => {},
      confirmOnNo: () => {},
      // PDF表示ウィンドウ
      pdfWnd: null,
      searchCallbackFlag: false,
      phraseCallbackFlag: false,

      facilityId: null, // 施設ID
      patientId: null,  // 患者ID
      type: null,       // タイプ view時は閉じるボタン表示 各リンクなし
    }
  },

  created: function() {
    // システム管理者 または 薬剤師
    this.$store.dispatch('USER_ADMIN_PHARMACIST')

    this.facilityId = this.$route.params['facilityId']
    this.patientId = this.$route.params['patientId']
    if ('type' in this.$route.params) {
      this.type = this.$route.params['type']
    }
    var self = this
    self.phraseCallbackFlag = false
    var callback = function () {
      self.phraseCallbackFlag = true
    }
    this.$store.dispatch('PHRASE_SEARCH', {callback: callback})
    if (this.type === 'view') {
      // 報告書からの遷移時、直近の計画書を初期表示
      this.showPlan(null, this.patientId, 0, false)
    } else if ('planId' in this.$route.params) {
      this.showPlan(this.$route.params.planId, null, 0, false)
    }
  },
  mounted () {
    // ヘルプボタン表示
    utils.helpModalShow()
  },
  computed: {
    authToken() {
      return window.localStorage.getItem('access_token')
    },
    notify() {
      return this.$store.getters.planNotify
    },
    /** 支払方法 */
    payMethodName() {
      var arr = this.$store.getters.phrases[constant.phraseType.PAY_METHOD]
      if (!arr) return ''
      for (var i = 0; i < arr.length; i++) {
        if (arr[i].attributes['phrase-code'] == this.plan.pay_method) {
          return arr[i].attributes['phrase']
        }
      }
      return ''
    },
    /** 訪問計画 */
    visitIntervalName() {
      var arr = this.$store.getters.phrases[constant.phraseType.VISIT_INTERVAL]
      if (!arr) return ''
      for (var i = 0; i < arr.length; i++) {
        if (arr[i].attributes['phrase-code'] == this.plan.visit_interval) {
          return arr[i].attributes['phrase']
        }
      }
      return ''
    },
    weekDayName() {
      var arr = this.$t('week_days')
      for (var i = 0; i < arr.length; i++) {
        if (arr[i].id == this.plan.visit_weekday) {
          return arr[i].text
        }
      }
      return ''
    },
    /** 医師からの情報 */
    diseaseNames() {
      var arr = this.$store.getters.phrases[constant.phraseType.DISEASE]
      if (!arr) return ''
      var tmp = []
      this.plan.disease_ids.forEach((id) => {
        arr.some((o) => {
          if (o.attributes['phrase-code'] == id) {
            tmp.push(o.attributes['phrase'])
            return true
          }
        }, this)
      }, this)
      if (utils.isPresent(this.plan['other_disease_name'])) {
        tmp.push(this.plan['other_disease_name'])
      }
      return tmp.join('、')
    },
    /** システム管理者 または 組織長かつ薬剤師 */
    isAdminOrPharmacistManager() {
      return this.$store.getters.userAdminOrPharmacistManager
    },
    /** apiローディング */
    loading () {
      return this.$store.getters.apiLoading
    }
  },

  methods: {
    /** 初期表示 */
    showPlan: function (plan_id = null, patient_id = null, index = 0, loadparams) {
      if (utils.isBlank(loadparams)) {
        loadparams = 'block'
      }
      if (loadparams === true) {
        this.searchCallbackFlag = false
      }
      this.$store.dispatch('PLAN_GET', {
          data: {plan_id: plan_id, patient_id: patient_id, index: index},
          callback: this.onGetPlan,
          loadparams: loadparams
        }
      )
    },
    onGetPlan: function (plan) {
      for(var key in this.plan){
        this.plan[key] = plan[key];
      }
      this.searchCallbackFlag = true
    },
    /** <- 前回 */
    onClickPrevPlan: function () {
      if (!this.plan.is_first) {
        this.showPlan(null, this.plan.patient_id, this.plan.index + 1, 'block')
      }
    },
    /** 次回 -> */
    onClickNextPlan: function () {
      if (!this.plan.is_latest) {
        this.showPlan(null, this.plan.patient_id, this.plan.index - 1, 'block')
      }
    },

    /** 翌月計画書自動作成ボタン */
    onClickSaveNextMonth: function () {
      this.$store.dispatch(
        'PLAN_EXIST_NEXT_MONTH',
        { data: {plan_id: this.plan.plan_id}, callback: this.confirmSaveNextPlan }
      )
    },
    confirmSaveNextPlan (data) {
      var save = () => {
        this.$store.dispatch(
          'PLAN_SAVE_NEXT_MONTH',
          { data: {plan_id: this.plan.plan_id}, callback: this.onSaveNextPlan }
        )
      }
      if (data.exist) {
        // 確認ダイアログ設定+表示
        this.confirmMessage = this.$t('plan.confirm_message')
        this.confirmOnYes = save
        this.confirmOnNo = () => {}
        this.$refs.confirmBtn.click()
      } else {
        save()
      }
    },
    onSaveNextPlan(data) {
      this.isListKeep = false
      this.showPlan(data.plan_id)
    },

    /** 編集ボタン */
    onClickEdit: function () {
      // this.$router.push({ name: 'PlanEdit', params: { planId: this.plan.plan_id }})
      if (utils.isPresent(this.facilityId) && utils.isPresent(this.patientId)) {
        this.$router.push({ path: '/plans/edit/' + this.facilityId + '/' + this.patientId + '/' + this.plan.plan_id})
      } else {
        this.$router.push({name: 'PlanEdit', params: { planId: this.plan.plan_id }})
      }
    },
    /** 複製新規ボタン */
    onClickCopyNewEdit: function () {
      this.$router.push({ path: '/plans/create/' + this.facilityId + '/' + this.patientId + '/' + this.plan.plan_id})
    },

    /** 削除ボタン */
    onClickRemove: function () {
      var self = this
      // 確認ダイアログ設定+表示
      this.confirmMessage = this.$t('plan.confirm_remove_message')
      this.confirmOnYes = () => {
        self.$store.dispatch(
          'PLAN_REMOVE',
          { data: {plan_id: self.plan.plan_id}, callback: (data) => { self.goPatientsPlan(false) } }
        )
      }
      this.confirmOnNo = () => {}
      this.$refs.confirmBtn.click()
    },

    /** 取引中止 ／ 取引再開ボタン */
    onClickEnable: function () {
      this.$store.dispatch(
        'PLAN_SET_ENABLE_PATIENT',
        { data: {patient_id: this.plan.patient_id, enable_flag: !this.plan.patient_enable},
          callback: this.onSetEnable }
      )
    },
    onSetEnable (data) {
      this.plan.patient_enable = data.enable_flag
    },

    /** PDF出力ボタン */
    onClickPdf: function() {
      this.pdfWnd = window.open(constant.html.loading, '_blank')
      // this.pdfWnd.document.open()
      // this.pdfWnd.document.write(
      //   '<html><head><title>' + this.$t('Plan Detail') + '</title></head>' +
      //   '<body>' + this.$t('plan.output_pdf_wait_message') + '</body></html>')
      // this.pdfWnd.document.close();
      this.$store.dispatch(
        'PLAN_PDF',
        { data: {plan_id: this.plan.plan_id}, callback: this.onGetPdf ,loadparams: 'block'}
      )
    },
    onGetPdf: function(data) {
      this.pdfWnd.location.href = data.url
      // ファイル削除
      this.$store.dispatch(
        'PLAN_REMOVE_PDF',
        { data: {download_id: data.download_id}, callback: (data) => {} ,loadparams: 'block'}
      )
    },

    /** 患者検索に戻る */
    goPatientsList: function () {
      this.$router.push({ path: '/patients/list/', query: {'keep': 'true'}})
    },
    /** 計画書検索ページに戻る 削除の場合キープせずに再検索 */
    goPatientsPlan: function (keep) {
      if (keep) {
        this.$router.push({ path: '/patients/plan/' + this.facilityId + '/' + this.patientId, query: {'keep': 'true'}})
      } else {
        this.$router.push({ path: '/patients/plan/' + this.facilityId + '/' + this.patientId})
      }
    },

    /** 画像押下 */
    onClickImageModalShow: function () {
      var button = document.getElementById('imageModalButton')
      var img    = document.getElementById('imageModalImg')
      var text   = document.getElementById('imageModalText')
      img.src = this.plan.patient_avartar + '?token=' + this.authToken
      text.textContent = ''
      button.click() // モーダル表示 イベント発火
    },

    /** 日付 (和暦) 用 */
    getWareki: function (seireki_str) {
      if ((!seireki_str) || isNaN(Date.parse(seireki_str))) {
        return ''
      } else {
        return utils.sereki2Wareki(this.$t, new Date(Date.parse(seireki_str)))
      }
    },
    getSeireki: function (wareki_str) {
      return utils.wareki2Seireki(this.$t, wareki_str).toLocaleDateString()
    },
    getHHMM: function (seireki_str) {
      var d = new Date(Date.parse(seireki_str))
      return ("0"+d.getHours()).slice(-2) + ":" + ("0"+d.getMinutes()).slice(-2)
    },

    /** 画面を閉じる */
    onWindowClose: function () {
      window.open('about:blank','_self').close() // 画面を閉じる
    },
    backToTop: function () {
      window.scrollTo(0, 0)
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/scripts/plan-detail.js